/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IsClientExisting200Response
 */
export interface IsClientExisting200Response {
    /**
     * `true` when the client has been fully initialized and is ready to use.
     */
    _exists?: boolean;
}

/**
 * Check if a given object implements the IsClientExisting200Response interface.
 */
export function instanceOfIsClientExisting200Response(value: object): value is IsClientExisting200Response {
    return true;
}

export function IsClientExisting200ResponseFromJSON(json: any): IsClientExisting200Response {
    return IsClientExisting200ResponseFromJSONTyped(json, false);
}

export function IsClientExisting200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IsClientExisting200Response {
    if (json == null) {
        return json;
    }
    return {
        
        '_exists': json['exists'] == null ? undefined : json['exists'],
    };
}

export function IsClientExisting200ResponseToJSON(json: any): IsClientExisting200Response {
    return IsClientExisting200ResponseToJSONTyped(json, false);
}

export function IsClientExisting200ResponseToJSONTyped(value?: IsClientExisting200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exists': value['_exists'],
    };
}

